var map = {
	"./": 2974,
	"./App": 7391,
	"./App.css": 4050,
	"./App.tsx": 7391,
	"./Bootstrap.css": 7689,
	"./Constants": 6715,
	"./Constants.ts": 6715,
	"./api/Error": 3463,
	"./api/Error.ts": 3463,
	"./api/auth/ChangePassword": 5631,
	"./api/auth/ChangePassword.ts": 5631,
	"./api/auth/ChangePreferences": 3578,
	"./api/auth/ChangePreferences.ts": 3578,
	"./api/auth/CreateUser": 5401,
	"./api/auth/CreateUser.ts": 5401,
	"./api/auth/DeleteAccount": 5374,
	"./api/auth/DeleteAccount.ts": 5374,
	"./api/auth/LoginAttempt": 6312,
	"./api/auth/LoginAttempt.ts": 6312,
	"./api/auth/ResetPassword": 3502,
	"./api/auth/ResetPassword.ts": 3502,
	"./api/auth/ValidateToken": 4667,
	"./api/auth/ValidateToken.ts": 4667,
	"./api/email/InitiateEmailChange": 5459,
	"./api/email/InitiateEmailChange.ts": 5459,
	"./api/email/SendOtp": 8941,
	"./api/email/SendOtp.ts": 8941,
	"./api/email/SetNewEmail": 64,
	"./api/email/SetNewEmail.ts": 64,
	"./api/email/VerifyOtp": 4508,
	"./api/email/VerifyOtp.ts": 4508,
	"./api/tools/chatBot/ChatBot": 5498,
	"./api/tools/chatBot/ChatBot.ts": 5498,
	"./api/tools/chatBot/ChatBotLikes": 0,
	"./api/tools/chatBot/ChatBotLikes.ts": 0,
	"./api/tools/p5f/DeleteP5F": 9087,
	"./api/tools/p5f/DeleteP5F.ts": 9087,
	"./api/tools/p5f/GetP5F": 1198,
	"./api/tools/p5f/GetP5F.ts": 1198,
	"./api/tools/p5f/SaveP5F": 3145,
	"./api/tools/p5f/SaveP5F.ts": 3145,
	"./api/webUsage/GetWebUsageSummary": 9456,
	"./api/webUsage/GetWebUsageSummary.ts": 9456,
	"./api/webUsage/ReportWebUsage": 3520,
	"./api/webUsage/ReportWebUsage.ts": 3520,
	"./components/Footer": 4604,
	"./components/Footer.tsx": 4604,
	"./components/LoadIcon": 434,
	"./components/LoadIcon.tsx": 434,
	"./components/LoadingPage": 8772,
	"./components/LoadingPage.tsx": 8772,
	"./components/LoginSoon": 6855,
	"./components/LoginSoon.tsx": 6855,
	"./components/LogoSvg": 4976,
	"./components/LogoSvg.tsx": 4976,
	"./components/auth/Account": 2063,
	"./components/auth/Account.tsx": 2063,
	"./components/auth/EditAccount": 4363,
	"./components/auth/EditAccount.tsx": 4363,
	"./components/auth/ForgotPassword": 3542,
	"./components/auth/ForgotPassword.tsx": 3542,
	"./components/auth/Login": 7113,
	"./components/auth/Login.tsx": 7113,
	"./components/auth/LoginWall": 9665,
	"./components/auth/LoginWall.tsx": 9665,
	"./components/auth/NotAdmin": 7656,
	"./components/auth/NotAdmin.tsx": 7656,
	"./components/auth/OtpVerifier": 8683,
	"./components/auth/OtpVerifier.tsx": 8683,
	"./components/auth/Payment": 7584,
	"./components/auth/Payment.tsx": 7584,
	"./components/auth/Register": 9371,
	"./components/auth/Register.tsx": 9371,
	"./components/auth/Support": 3075,
	"./components/auth/Support.tsx": 3075,
	"./components/bootstrap_icons/Book": 1202,
	"./components/bootstrap_icons/Book.tsx": 1202,
	"./components/bootstrap_icons/House": 5033,
	"./components/bootstrap_icons/House.tsx": 5033,
	"./components/bootstrap_icons/Menu": 3324,
	"./components/bootstrap_icons/Menu.tsx": 3324,
	"./components/bootstrap_icons/RightArrow": 8072,
	"./components/bootstrap_icons/RightArrow.tsx": 8072,
	"./components/bootstrap_icons/SearchIcon": 5298,
	"./components/bootstrap_icons/SearchIcon.tsx": 5298,
	"./components/bootstrap_icons/SendArrow": 4136,
	"./components/bootstrap_icons/SendArrow.tsx": 4136,
	"./components/bootstrap_icons/Stars": 7182,
	"./components/bootstrap_icons/Stars.tsx": 7182,
	"./components/bootstrap_icons/ThumbsDown": 9402,
	"./components/bootstrap_icons/ThumbsDown.tsx": 9402,
	"./components/bootstrap_icons/ThumbsUp": 181,
	"./components/bootstrap_icons/ThumbsUp.tsx": 181,
	"./components/bootstrap_icons/User": 396,
	"./components/bootstrap_icons/User.tsx": 396,
	"./components/chat_bot/ChatWindow": 9856,
	"./components/chat_bot/ChatWindow.tsx": 9856,
	"./components/commandments/CommandmentsRoot": 8230,
	"./components/commandments/CommandmentsRoot.tsx": 8230,
	"./components/commandments/pages/1-NorthStar": 9780,
	"./components/commandments/pages/1-NorthStar.tsx": 9780,
	"./components/commandments/pages/10-Lead": 7709,
	"./components/commandments/pages/10-Lead.tsx": 7709,
	"./components/commandments/pages/2-ReallyMatter": 3570,
	"./components/commandments/pages/2-ReallyMatter.tsx": 3570,
	"./components/commandments/pages/3-CompeteWin": 108,
	"./components/commandments/pages/3-CompeteWin.tsx": 108,
	"./components/commandments/pages/4-Moat": 2317,
	"./components/commandments/pages/4-Moat.tsx": 2317,
	"./components/commandments/pages/5-Capabilities": 3775,
	"./components/commandments/pages/5-Capabilities.tsx": 3775,
	"./components/commandments/pages/6-Expand": 2548,
	"./components/commandments/pages/6-Expand.tsx": 2548,
	"./components/commandments/pages/7-GainsAndGoals": 5394,
	"./components/commandments/pages/7-GainsAndGoals.tsx": 5394,
	"./components/commandments/pages/8-Innovate": 528,
	"./components/commandments/pages/8-Innovate.tsx": 528,
	"./components/commandments/pages/9-Levels": 5996,
	"./components/commandments/pages/9-Levels.tsx": 5996,
	"./components/concepts/ConceptRoot": 907,
	"./components/concepts/ConceptRoot.tsx": 907,
	"./components/concepts/Wedges": 1160,
	"./components/concepts/Wedges.tsx": 1160,
	"./components/concepts/components/Wedge": 1458,
	"./components/concepts/components/Wedge.tsx": 1458,
	"./components/concepts/pages/AdjacentMarketExpansion": 9939,
	"./components/concepts/pages/AdjacentMarketExpansion.tsx": 9939,
	"./components/concepts/pages/BlueOcean": 2692,
	"./components/concepts/pages/BlueOcean.tsx": 2692,
	"./components/concepts/pages/Cage": 3896,
	"./components/concepts/pages/Cage.tsx": 3896,
	"./components/concepts/pages/ConsumptionChain": 3848,
	"./components/concepts/pages/ConsumptionChain.tsx": 3848,
	"./components/concepts/pages/Differentiation": 5229,
	"./components/concepts/pages/Differentiation.tsx": 5229,
	"./components/concepts/pages/EntryModes": 144,
	"./components/concepts/pages/EntryModes.tsx": 144,
	"./components/concepts/pages/ExperienceCurve": 9455,
	"./components/concepts/pages/ExperienceCurve.tsx": 9455,
	"./components/concepts/pages/IndirectAssault": 3221,
	"./components/concepts/pages/IndirectAssault.tsx": 3221,
	"./components/concepts/pages/InternationalStrategy": 8049,
	"./components/concepts/pages/InternationalStrategy.tsx": 8049,
	"./components/concepts/pages/JobsToBeDoneConcept": 2102,
	"./components/concepts/pages/JobsToBeDoneConcept.tsx": 2102,
	"./components/concepts/pages/PortersFiveForces": 9493,
	"./components/concepts/pages/PortersFiveForces.tsx": 9493,
	"./components/concepts/pages/PortersGenericStrategies": 4645,
	"./components/concepts/pages/PortersGenericStrategies.tsx": 4645,
	"./components/concepts/pages/ScaleCurve": 3047,
	"./components/concepts/pages/ScaleCurve.tsx": 3047,
	"./components/concepts/pages/StrategyCanvas": 2319,
	"./components/concepts/pages/StrategyCanvas.tsx": 2319,
	"./components/concepts/pages/SunkCostFallacy": 8444,
	"./components/concepts/pages/SunkCostFallacy.tsx": 8444,
	"./components/concepts/pages/ThreeHorizons": 3686,
	"./components/concepts/pages/ThreeHorizons.tsx": 3686,
	"./components/concepts/pages/TripleA": 4979,
	"./components/concepts/pages/TripleA.tsx": 4979,
	"./components/focuses/FocusRoot": 332,
	"./components/focuses/FocusRoot.tsx": 332,
	"./components/focuses/maps/CapabilitiesMap": 210,
	"./components/focuses/maps/CapabilitiesMap.tsx": 210,
	"./components/focuses/maps/MainMap": 4789,
	"./components/focuses/maps/MainMap.tsx": 4789,
	"./components/focuses/maps/UniqueValueMap": 4490,
	"./components/focuses/maps/UniqueValueMap.tsx": 4490,
	"./components/focuses/pages/CustomerUnmetNeeds": 4809,
	"./components/focuses/pages/CustomerUnmetNeeds.tsx": 4809,
	"./components/focuses/pages/FoundationInPurpose": 1561,
	"./components/focuses/pages/FoundationInPurpose.tsx": 1561,
	"./components/focuses/pages/OperatingArena": 6059,
	"./components/focuses/pages/OperatingArena.tsx": 6059,
	"./components/focuses/pages/SafeguardsAgainstImitation": 2199,
	"./components/focuses/pages/SafeguardsAgainstImitation.tsx": 2199,
	"./components/focuses/pages/UnifiedBusinessModel": 5674,
	"./components/focuses/pages/UnifiedBusinessModel.tsx": 5674,
	"./components/main_pages/AnimationTest": 3448,
	"./components/main_pages/AnimationTest.tsx": 3448,
	"./components/main_pages/Codex": 7859,
	"./components/main_pages/Codex.tsx": 7859,
	"./components/main_pages/CommandmentsHome": 4151,
	"./components/main_pages/CommandmentsHome.tsx": 4151,
	"./components/main_pages/Dashboard": 5471,
	"./components/main_pages/Dashboard.tsx": 5471,
	"./components/main_pages/ErrorPage": 8893,
	"./components/main_pages/ErrorPage.tsx": 8893,
	"./components/main_pages/FocusHome": 495,
	"./components/main_pages/FocusHome.tsx": 495,
	"./components/main_pages/Home": 6529,
	"./components/main_pages/Home.tsx": 6529,
	"./components/main_pages/QrCode": 7798,
	"./components/main_pages/QrCode.tsx": 7798,
	"./components/main_pages/Team": 4643,
	"./components/main_pages/Team.tsx": 4643,
	"./components/main_pages/Videos": 7792,
	"./components/main_pages/Videos.tsx": 7792,
	"./components/navigation/BackToTop": 8069,
	"./components/navigation/BackToTop.tsx": 8069,
	"./components/navigation/Breadcrumb": 559,
	"./components/navigation/Breadcrumb.tsx": 559,
	"./components/navigation/BreadcrumbsAndArrows": 5787,
	"./components/navigation/BreadcrumbsAndArrows.tsx": 5787,
	"./components/navigation/MasterSidebar": 5412,
	"./components/navigation/MasterSidebar.tsx": 5412,
	"./components/navigation/Nav": 7737,
	"./components/navigation/Nav.tsx": 7737,
	"./components/navigation/NavArrows": 2023,
	"./components/navigation/NavArrows.tsx": 2023,
	"./components/navigation/SearchBar": 3148,
	"./components/navigation/SearchBar.tsx": 3148,
	"./components/navigation/SearchPage": 641,
	"./components/navigation/SearchPage.tsx": 641,
	"./components/pathways/PathwayRoot": 4707,
	"./components/pathways/PathwayRoot.tsx": 4707,
	"./components/pathways/pages/CustomerUnmetNeeds/CJobsToBeDonePathway": 228,
	"./components/pathways/pages/CustomerUnmetNeeds/CJobsToBeDonePathway.tsx": 228,
	"./components/pathways/pages/CustomerUnmetNeeds/PainPointsPathway": 666,
	"./components/pathways/pages/CustomerUnmetNeeds/PainPointsPathway.tsx": 666,
	"./components/pathways/pages/CustomerUnmetNeeds/UniqueValuePathway": 8321,
	"./components/pathways/pages/CustomerUnmetNeeds/UniqueValuePathway.tsx": 8321,
	"./components/pathways/pages/FoundationInPurpose/AlignmentPathway": 3086,
	"./components/pathways/pages/FoundationInPurpose/AlignmentPathway.tsx": 3086,
	"./components/pathways/pages/FoundationInPurpose/DefineMissionPathway": 3660,
	"./components/pathways/pages/FoundationInPurpose/DefineMissionPathway.tsx": 3660,
	"./components/pathways/pages/FoundationInPurpose/DefineValuesPathway": 4914,
	"./components/pathways/pages/FoundationInPurpose/DefineValuesPathway.tsx": 4914,
	"./components/pathways/pages/FoundationInPurpose/DefineVisionPathway": 8724,
	"./components/pathways/pages/FoundationInPurpose/DefineVisionPathway.tsx": 8724,
	"./components/pathways/pages/FoundationInPurpose/EthicsPathway": 51,
	"./components/pathways/pages/FoundationInPurpose/EthicsPathway.tsx": 51,
	"./components/pathways/pages/OperatingArena/ChosenPositionPathway": 5078,
	"./components/pathways/pages/OperatingArena/ChosenPositionPathway.tsx": 5078,
	"./components/pathways/pages/OperatingArena/CustomerIdentificationPathway": 4453,
	"./components/pathways/pages/OperatingArena/CustomerIdentificationPathway.tsx": 4453,
	"./components/pathways/pages/OperatingArena/EvaluateIndustryPathway": 9290,
	"./components/pathways/pages/OperatingArena/EvaluateIndustryPathway.tsx": 9290,
	"./components/pathways/pages/OperatingArena/JobsToBeDonePathway": 3611,
	"./components/pathways/pages/OperatingArena/JobsToBeDonePathway.tsx": 3611,
	"./components/pathways/pages/OperatingArena/SegmentsPathway": 2937,
	"./components/pathways/pages/OperatingArena/SegmentsPathway.tsx": 2937,
	"./components/pathways/pages/SafeguardsAgainstImitation/CapabilitiesAdvantagePathway": 8516,
	"./components/pathways/pages/SafeguardsAgainstImitation/CapabilitiesAdvantagePathway.tsx": 8516,
	"./components/pathways/pages/SafeguardsAgainstImitation/CustomerAdvantagePathway": 4894,
	"./components/pathways/pages/SafeguardsAgainstImitation/CustomerAdvantagePathway.tsx": 4894,
	"./components/pathways/pages/SafeguardsAgainstImitation/LocationAdvantagePathway": 2939,
	"./components/pathways/pages/SafeguardsAgainstImitation/LocationAdvantagePathway.tsx": 2939,
	"./components/pathways/pages/SafeguardsAgainstImitation/ManufacturingAdvantagePathway": 3968,
	"./components/pathways/pages/SafeguardsAgainstImitation/ManufacturingAdvantagePathway.tsx": 3968,
	"./components/pathways/pages/SafeguardsAgainstImitation/NetworkAdvantagePathway": 3160,
	"./components/pathways/pages/SafeguardsAgainstImitation/NetworkAdvantagePathway.tsx": 3160,
	"./components/pathways/pages/SafeguardsAgainstImitation/ResourceAdvantagePathway": 7230,
	"./components/pathways/pages/SafeguardsAgainstImitation/ResourceAdvantagePathway.tsx": 7230,
	"./components/pathways/pages/SafeguardsAgainstImitation/SwitchingCostAdvantagePathway": 7573,
	"./components/pathways/pages/SafeguardsAgainstImitation/SwitchingCostAdvantagePathway.tsx": 7573,
	"./components/pathways/pages/SafeguardsAgainstImitation/TimingAdvantagePathway": 6343,
	"./components/pathways/pages/SafeguardsAgainstImitation/TimingAdvantagePathway.tsx": 6343,
	"./components/pathways/pages/UnifiedBusinessModel/AnalyzeFirmActivitiesPathway": 1577,
	"./components/pathways/pages/UnifiedBusinessModel/AnalyzeFirmActivitiesPathway.tsx": 1577,
	"./components/pathways/pages/UnifiedBusinessModel/ExistingRAndCPathway": 2683,
	"./components/pathways/pages/UnifiedBusinessModel/ExistingRAndCPathway.tsx": 2683,
	"./components/pathways/pages/UnifiedBusinessModel/ImplementChangesPathway": 1204,
	"./components/pathways/pages/UnifiedBusinessModel/ImplementChangesPathway.tsx": 1204,
	"./components/templates/Error": 8755,
	"./components/templates/Error.tsx": 8755,
	"./components/templates/HorizontalAccordion": 5147,
	"./components/templates/HorizontalAccordion.tsx": 5147,
	"./components/templates/Message": 5380,
	"./components/templates/Message.tsx": 5380,
	"./components/templates/PageTitleBanner": 1374,
	"./components/templates/PageTitleBanner.tsx": 1374,
	"./components/templates/SidebarPage": 664,
	"./components/templates/SidebarPage.tsx": 664,
	"./components/tools/ToolsHome": 4177,
	"./components/tools/ToolsHome.tsx": 4177,
	"./components/tools/ToolsRoot": 8352,
	"./components/tools/ToolsRoot.tsx": 8352,
	"./components/tools/pages/PortersFiveForcesCalculator": 4329,
	"./components/tools/pages/PortersFiveForcesCalculator.tsx": 4329,
	"./components/tools/pages/StrategyCanvasCalculator": 2661,
	"./components/tools/pages/StrategyCanvasCalculator.tsx": 2661,
	"./components/tools/pages/ThreeHorizonsCalculator": 6344,
	"./components/tools/pages/ThreeHorizonsCalculator.tsx": 6344,
	"./context/UserContext": 8504,
	"./context/UserContext.ts": 8504,
	"./design_lib": 9373,
	"./design_lib/": 9373,
	"./design_lib/Headers": 3801,
	"./design_lib/Headers.tsx": 3801,
	"./design_lib/Image": 5268,
	"./design_lib/Image.tsx": 5268,
	"./design_lib/Paragraph": 3293,
	"./design_lib/Paragraph.tsx": 3293,
	"./design_lib/RelatedFrameworks": 929,
	"./design_lib/RelatedFrameworks.tsx": 929,
	"./design_lib/Updated": 3706,
	"./design_lib/Updated.tsx": 3706,
	"./design_lib/index": 9373,
	"./design_lib/index.ts": 9373,
	"./hooks/useChatBot": 6995,
	"./hooks/useChatBot.ts": 6995,
	"./hooks/useElementSize": 4254,
	"./hooks/useElementSize.ts": 4254,
	"./hooks/useUser": 8021,
	"./hooks/useUser.ts": 8021,
	"./hooks/useWindowSize": 6791,
	"./hooks/useWindowSize.ts": 6791,
	"./index": 2974,
	"./index.tsx": 2974,
	"./init/InitializeAxios": 4121,
	"./init/InitializeAxios.ts": 4121,
	"./lib/data/AnimationData": 5305,
	"./lib/data/AnimationData.ts": 5305,
	"./lib/data/Categories": 2739,
	"./lib/data/Categories.ts": 2739,
	"./lib/data/CodexViews": 6120,
	"./lib/data/CodexViews.ts": 6120,
	"./lib/data/Commandments": 4845,
	"./lib/data/Commandments.ts": 4845,
	"./lib/data/Concepts": 2378,
	"./lib/data/Concepts.ts": 2378,
	"./lib/data/Focuses": 6439,
	"./lib/data/Focuses.ts": 6439,
	"./lib/data/Pathways": 3120,
	"./lib/data/Pathways.ts": 3120,
	"./lib/data/Students": 6079,
	"./lib/data/Students.ts": 6079,
	"./lib/data/Tools": 500,
	"./lib/data/Tools.ts": 500,
	"./lib/data/Videos": 1863,
	"./lib/data/Videos.ts": 1863,
	"./lib/data/Views": 4345,
	"./lib/data/Views.ts": 4345,
	"./lib/img/BYU_Logos/BYU.jpg": 1034,
	"./lib/img/BYU_Logos/BYU_Cougars_logo.svg": 1263,
	"./lib/img/BYU_Logos/Combined Mark/EPS/BYU MonogramWordmark_black.eps": 6181,
	"./lib/img/BYU_Logos/Combined Mark/EPS/BYU MonogramWordmark_navy.eps": 7276,
	"./lib/img/BYU_Logos/Combined Mark/EPS/BYU MonogramWordmark_white.eps": 7107,
	"./lib/img/BYU_Logos/Combined Mark/PNG/BYU MonogramWordmark_black@2x.png": 808,
	"./lib/img/BYU_Logos/Combined Mark/PNG/BYU MonogramWordmark_navy@2x.png": 7151,
	"./lib/img/BYU_Logos/Combined Mark/PNG/BYU MonogramWordmark_white@2x.png": 9802,
	"./lib/img/BYU_Logos/Combined Mark/SVG/BYU MonogramWordmark_black.svg": 117,
	"./lib/img/BYU_Logos/Combined Mark/SVG/BYU MonogramWordmark_navy.svg": 8040,
	"./lib/img/BYU_Logos/Combined Mark/SVG/BYU MonogramWordmark_white.svg": 1275,
	"./lib/img/BYU_Logos/Monogram/EPS/BYU monogram_black.eps": 5090,
	"./lib/img/BYU_Logos/Monogram/EPS/BYU monogram_navy.eps": 5997,
	"./lib/img/BYU_Logos/Monogram/EPS/BYU monogram_white.eps": 2456,
	"./lib/img/BYU_Logos/Monogram/PNG/BYU monogram_black@2x.png": 6023,
	"./lib/img/BYU_Logos/Monogram/PNG/BYU monogram_navy@2x.png": 6902,
	"./lib/img/BYU_Logos/Monogram/PNG/BYU monogram_white@2x.png": 1993,
	"./lib/img/BYU_Logos/Monogram/SVG/BYU monogram_black.svg": 5142,
	"./lib/img/BYU_Logos/Monogram/SVG/BYU monogram_navy.svg": 8461,
	"./lib/img/BYU_Logos/Monogram/SVG/BYU monogram_white.svg": 1020,
	"./lib/img/CodexTool.jpg": 4109,
	"./lib/img/DaVinciPillars.jpg": 3619,
	"./lib/img/DaVinciShape.png": 855,
	"./lib/img/FocusTool.jpg": 3668,
	"./lib/img/Logo.svg": 4165,
	"./lib/img/MagnifyingGlass_old.jpg": 2969,
	"./lib/img/Magnifying_Glass.png": 7686,
	"./lib/img/concepts/AAA_old.png": 4359,
	"./lib/img/concepts/BusinessModels.png": 6108,
	"./lib/img/concepts/CAGE_framework.png": 4601,
	"./lib/img/concepts/ConsumptionChain_old.jpg": 3058,
	"./lib/img/concepts/Consumption_Chain.png": 2585,
	"./lib/img/concepts/Differentiation_Porters_Generic_Strategies.png": 6069,
	"./lib/img/concepts/Differentiation_Venn_Diagram.png": 8311,
	"./lib/img/concepts/EntryModes.png": 2152,
	"./lib/img/concepts/ExperienceCurve.png": 2887,
	"./lib/img/concepts/GrowthShareMatrixCorporateStrategy.png": 3525,
	"./lib/img/concepts/InternationalStrategy_old.jpg": 3667,
	"./lib/img/concepts/International_Strategy.png": 3476,
	"./lib/img/concepts/Jobs_To_Be_Done.png": 9077,
	"./lib/img/concepts/Jobs_To_Be_Done_Types.png": 4871,
	"./lib/img/concepts/MECE.png": 7518,
	"./lib/img/concepts/Porter'sFiveForcesGraphic_old.png": 3702,
	"./lib/img/concepts/Porter's_Five_Forces.png": 5615,
	"./lib/img/concepts/PyramidPrinciple.png": 7924,
	"./lib/img/concepts/ScaleCurve.png": 2271,
	"./lib/img/concepts/SunkCost.png": 674,
	"./lib/img/concepts/ThreeHorizons_old.png": 7232,
	"./lib/img/concepts/Three_Horizons.png": 7803,
	"./lib/img/concepts/Triple_A.png": 5000,
	"./lib/img/differentiation_wedges/Aged_Paper_(Background).png": 978,
	"./lib/img/differentiation_wedges/Bottom_Line.png": 2810,
	"./lib/img/differentiation_wedges/Full_Wedge.png": 3264,
	"./lib/img/differentiation_wedges/Half_Wedge.png": 6536,
	"./lib/img/differentiation_wedges/Top_Line.png": 7068,
	"./lib/img/focuses/CustomerUnmetNeeds.jpg": 7687,
	"./lib/img/focuses/FoundationInPurpose.jpg": 6363,
	"./lib/img/focuses/OperatingArena.jpg": 3033,
	"./lib/img/focuses/SafeguardsAgainstImitation.jpg": 6149,
	"./lib/img/focuses/UnifiedBusinessModel.jpg": 5376,
	"./lib/img/icons/back-arrow.png": 2504,
	"./lib/img/icons/collapse.png": 5032,
	"./lib/img/icons/youtubeIcon.png": 7525,
	"./lib/img/letters/C.png": 9851,
	"./lib/img/letters/F.png": 6518,
	"./lib/img/letters/O.png": 6519,
	"./lib/img/letters/S.png": 1883,
	"./lib/img/letters/U.png": 1021,
	"./lib/img/loginBG.png": 8168,
	"./lib/img/magnifyingGlass_older.png": 5992,
	"./lib/img/pathways/AlignmentPathway.jpg": 149,
	"./lib/img/pathways/AnalyzeFirmActivitiesPathway.jpg": 3093,
	"./lib/img/pathways/CJobsToBeDonePathway.jpg": 4733,
	"./lib/img/pathways/ChosenPositionPathway.jpg": 3375,
	"./lib/img/pathways/CustomerIdentificationPathway.jpg": 4188,
	"./lib/img/pathways/DefineMission.png": 9705,
	"./lib/img/pathways/DefineMissionPathway.jpg": 8559,
	"./lib/img/pathways/DefineValuesPathway.jpg": 9799,
	"./lib/img/pathways/DefineVision.png": 9955,
	"./lib/img/pathways/DefineVisionPathway.jpg": 9497,
	"./lib/img/pathways/EthicsPathway.jpg": 5638,
	"./lib/img/pathways/EvaluateIndustryPathway.jpg": 4907,
	"./lib/img/pathways/ExistingRAndCPathway.jpg": 5259,
	"./lib/img/pathways/ImplementChangesPathway.jpg": 96,
	"./lib/img/pathways/JobsToBeDone.png": 9566,
	"./lib/img/pathways/JobsToBeDonePathway.jpg": 3482,
	"./lib/img/pathways/LemonadeStand.jpg": 2741,
	"./lib/img/pathways/PainPoints.png": 3991,
	"./lib/img/pathways/PainPointsPathway.jpg": 3853,
	"./lib/img/pathways/SegmentsPathway.jpg": 2280,
	"./lib/img/pathways/UniqueValuePathway.jpg": 6932,
	"./lib/img/pathwaysArrow.svg": 3460,
	"./lib/img/team/a_rich.jpg": 9478,
	"./lib/img/team/c_procuniar.jpg": 6511,
	"./lib/img/team/c_scott.jpg": 1689,
	"./lib/img/team/d_rush.jpg": 5137,
	"./lib/img/team/j_heninger.jpg": 8263,
	"./lib/img/team/j_oldroyd.jpg": 5340,
	"./lib/img/team/m_briggs.jpg": 350,
	"./lib/img/team/p_pond.jpg": 6114,
	"./lib/img/team/strategy-instructors.jpg": 3196,
	"./lib/img/team/t_gubler.jpg": 6832,
	"./lib/img/team/t_hill.jpg": 2274,
	"./lib/img/tools/PortersFiveForces.jpg": 1581,
	"./lib/img/tools/StrategyCanvas.jpg": 6835,
	"./lib/img/tools/ThreeHorizons.jpg": 7554,
	"./lib/img/unused/Barriers_To_Entry.png": 1654,
	"./lib/img/unused/Blockbuster.png": 643,
	"./lib/img/unused/Competitive_Advantage_ 2.png": 491,
	"./lib/img/unused/Minimum_Efficient_Scale 2.png": 9858,
	"./lib/img/unused/Saw.png": 1948,
	"./lib/img/videosBG.png": 9917,
	"./types/JsonType": 7996,
	"./types/JsonType.ts": 7996,
	"./types/MessageType": 2151,
	"./types/MessageType.ts": 2151,
	"./types/UserType": 677,
	"./types/UserType.ts": 677,
	"./utils/GetFuncParams": 2884,
	"./utils/GetFuncParams.ts": 2884,
	"./utils/PasswordValidator": 6585,
	"./utils/PasswordValidator.ts": 6585,
	"./utils/SetDocumentTitle": 7287,
	"./utils/SetDocumentTitle.ts": 7287
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5538;